import fpApiUtil from "./fp-api-util";

const RESOURCE = "factoryplan/master/jobchange/resources";
const ITEM = "factoryplan/master/jobchange/jctimeitems";
const ITEM_GROUP = "factoryplan/master/jobchange/jctimeitemgroups";
const ROUTE = "factoryplan/master/jobchange/jctimes";
const ROUTE_GROUP = "factoryplan/master/jobchange/jctimegroups";

const getResources = (params) => fpApiUtil.postParams(RESOURCE, params);
const upsertResources = (changes) => fpApiUtil.postChanges(`${RESOURCE}/save`, changes);

const getItemJobChanges = (params) => fpApiUtil.postParams(ITEM, params);
const upsertItemJobChanges = (changes) => fpApiUtil.postChanges(`${ITEM}/save`, changes);
const removeItemJobChanges = (changes) => fpApiUtil.postChanges(`${ITEM}/delete`, changes);

const getItemGroupJobChanges = (params) => fpApiUtil.postParams(ITEM_GROUP, params);
const upsertItemGroupJobChanges = (changes) => fpApiUtil.postChanges(`${ITEM_GROUP}/save`, changes);
const removeItemGroupJobChanges = (changes) => fpApiUtil.postChanges(`${ITEM_GROUP}/delete`, changes);

const getRouteJobChanges = (params) => fpApiUtil.postParams(ROUTE, params);
const upsertRouteJobChanges = (changes) => fpApiUtil.postChanges(`${ROUTE}/save`, changes);
const removeRouteJobChanges = (changes) => fpApiUtil.postChanges(`${ROUTE}/delete`, changes);

const getRouteGroupJobChanges = (params) => fpApiUtil.postParams(ROUTE_GROUP, params);
const upsertRouteGroupJobChanges = (changes) => fpApiUtil.postChanges(`${ROUTE_GROUP}/save`, changes);
const removeRouteGroupJobChanges = (changes) => fpApiUtil.postChanges(`${ROUTE_GROUP}/delete`, changes);

const fpJobChangeService = {
  getResources, upsertResources,
  getItemJobChanges, upsertItemJobChanges, removeItemJobChanges,
  getItemGroupJobChanges, upsertItemGroupJobChanges, removeItemGroupJobChanges,
  getRouteJobChanges, upsertRouteJobChanges, removeRouteJobChanges,
  getRouteGroupJobChanges, upsertRouteGroupJobChanges, removeRouteGroupJobChanges,
};
export default fpJobChangeService;
